import React, { useEffect, useState } from 'react';
import Head from 'next/head';
import App from '@/components/AppWrapper/AppWrapper';
import { SearchState } from '@/utils/searchState';
import { useRouter } from 'next/router';
import { categories, TCategory } from '@/utils/categories';
import { CategoryContext, IsJobPageContext } from '@/utils/context';
import { Props } from '../index';
import { Seo } from '@/components/Seo';
import { SEO_DATA } from '@/utils/seoConstants/home-page';
import { categorieTitleDescription } from '@/utils/categorieTitleDescription';
import ssr from '@/utils/ssr';
import removeJobIdFromUrl from '@/utils/removeJobIdFromUrl';
import { JOBS_FOUND_SPAN } from '@/utils/constants';

const CategoryOrJob = ({
  resultsState,
  searchStateProps,
  currentCategoryProps,
}: Props) => {
  const [currentCategory, setCurrentCategory] = useState<TCategory | any>(
    currentCategoryProps,
  );
  const [isJobPage, setIsJobPage] = useState(!currentCategory);
  const [searchState, setSearchState] = useState<SearchState>(searchStateProps);
  const {
    query: { category },
  } = useRouter();

  useEffect(() => {
    if (category) {
      const currCategory = categories.find(
        (el) => el.categoryLink === category,
      );
      setCurrentCategory(currCategory);
      setIsJobPage(!currCategory);
      setTimeout(() => {
        document?.getElementById(JOBS_FOUND_SPAN)?.scrollIntoView({
          behavior: `smooth`,
        });
      }, 100);
    }
  }, [category]);

  const onSearchStateChange = (searchState: SearchState) => {
    setSearchState((state) => {
      return {
        ...state,
        ...searchState,
      };
    });
  };

  const resetPage = () => {
    setSearchState((state) => {
      if (isJobPage) {
        removeJobIdFromUrl(resultsState.rawResults[0].hits[0]);
        setIsJobPage(false);
        return { ...state };
      }
      return {
        ...state,
        page: 1,
      };
    });
  };
  const categorieSeo = categorieTitleDescription(currentCategory?.categoryName);

  return (
    <div>
      {currentCategory && currentCategory.tags ? (
        <Head>
          <meta name="keywords" content={currentCategory.metatags} />
        </Head>
      ) : null}
      <IsJobPageContext.Provider value={isJobPage}>
        <CategoryContext.Provider value={currentCategory}>
          <App
            resetPage={resetPage}
            searchState={searchState}
            onSearchStateChange={onSearchStateChange}
            resultsState={resultsState}
          />
          <Seo
            {...SEO_DATA}
            customOGImage={
              currentCategory?.ogImage ||
              resultsState.rawResults[0].hits[0]?.bannerUrl
            }
            customTitle={categorieSeo?.title}
            customDescription={categorieSeo?.description}
          />
        </CategoryContext.Provider>
      </IsJobPageContext.Provider>
    </div>
  );
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export async function getServerSideProps(context) {
  return await ssr(context);
}

export default CategoryOrJob;
